import routerOptions0 from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@22.16.5_@vue+compiler-sfc@3.5.17_db0@0.3._1a55a1468e712cda0ed1dc737e89ec52/node_modules/nuxt/dist/pages/runtime/router.options.js";
import routerOptions1 from "/vercel/path0/node_modules/.pnpm/@una-ui+content@48.2.0_@parcel+watcher@2.5.1_@types+node@22.16.5_@unhead+vue@2.0.12_vue_7bbb611ebc9760b773bcbb23c662e4c1/node_modules/@una-ui/content/app/router.options.ts";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = routerOptions0.hashMode ?? false
export default {
...configRouterOptions,
...routerOptions0,
...routerOptions1,
}